import { AuthentificationService } from './auth/authentification.service';
import { PersonalHttpService } from './personal/personal.http.service';
import { ContractsHttpService } from './contracts/contracts.http.service';
import { ForSigningHttpService } from './forsigning/forsigning.http.service';
import { InformationHttpService } from './information/information.http.service';
import { ArrearsHttpService } from './arrears/arrears.http.service';
import { HistoryHttpService } from './history/history.http.service';
import { NotificationsHttpService } from './notifications/notifications.http.service';
import { CommunicationsHttpService } from './communications/communications.http.service';
import { ReportHttpService } from './report/report.http.service';
import { SettingsHttpService } from './settings/settings.http.service';
import { DocumentsHttpService } from './documents/documents.http.service';

export const APP_SERVICES: any[] = [
  AuthentificationService,
  PersonalHttpService,
  ContractsHttpService,
  ForSigningHttpService,
  InformationHttpService,
  ArrearsHttpService,
  HistoryHttpService,
  NotificationsHttpService,
  CommunicationsHttpService,
  ReportHttpService,
  SettingsHttpService,
  DocumentsHttpService,
];



// WEBPACK FOOTER //
// ./src/app/services/index.ts